import React from 'react';
import './singlePageDefaultAnswerItem.scss';
import check from '../../../../../../assets/check.svg';

const SinglePageDefaultAnswerItem = (props) => {
    return (
        <div onClick={() => handleClick(props)}
            className='answer-button'
            id={determineSelectionState(props)}>

            <div className='answer-content'>
                <div className='icon-container'>
                    <img className='check icon' src={check} alt=""/>
                </div>
                <p>{props.filter.answerDisplay}</p>
            </div>

        </div>
    );
};

const handleClick = (props) => {
    if (props.selectOnly) {
        return props.handleSelectOnly(props.filter, +props.position);
    }

    if (isSelected(props)) {
        return props.handleDeselect(props.filter,+props.position);
    } else {
        return props.handleSelect(props.filter, +props.position);
    }
}

const determineSelectionState = (props) => {
    if (isSelected(props)) {
        return "selected";
    } else {
        return "unselected";
    }
}

const isSelected = (props) => {
    if (props.selectedFilters[props.position]) {
        return true;
    }

    return false;
}

export default SinglePageDefaultAnswerItem;